const SMS_API_BASE = process.env.REACT_APP_SMS_API_URL
	|| 'https://simulateurs.aide-sociale.fr/simulateur-aide-sociale';

const parseResponse = async (response) => {
	const data = await response.json().catch(() => ({}));
	if (!response.ok) {
		throw new Error(data.message || data.error || 'Une erreur est survenue.');
	}
	if (data.success === false) {
		throw new Error(data.message || data.error || 'Une erreur est survenue.');
	}
	return data;
};

export const formatPhoneForApi = (phoneNumber) => {
	const clean = (phoneNumber || '').replace(/\s/g, '');
	if (!clean) return '';
	if (clean.startsWith('0033')) return clean;
	if (clean.startsWith('+33')) return '00' + clean.slice(1);
	if (clean.startsWith('33') && clean.length === 11) return '00' + clean;
	return '0033' + clean.replace(/^0/, '');
};

export const sendSmsCode = async (phoneNumber) => {
	const response = await fetch(`${SMS_API_BASE}/sms-send.php`, {
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		body: JSON.stringify({ phone: formatPhoneForApi(phoneNumber) }),
	});
	return parseResponse(response);
};

export const verifySmsCode = async (phoneNumber, code) => {
	const response = await fetch(`${SMS_API_BASE}/sms-verify.php`, {
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		body: JSON.stringify({
			phone: formatPhoneForApi(phoneNumber),
			code: (code || '').replace(/\s/g, ''),
		}),
	});
	return parseResponse(response);
};
